/**
 * QuickQuestions — scrollable chip bar for suggested questions
 */

import type { DisplayQuestion } from './types';
import styles from '../AiConsultantPage.module.css';

interface QuickQuestionsProps {
  questions: DisplayQuestion[];
  onSelect: (value: string) => void;
  disabled?: boolean;
}

export function QuickQuestions({ questions, onSelect, disabled = false }: QuickQuestionsProps) {
  return (
    <div className={styles.quickQuestions}>
      {questions.map((q, idx) => (
        <button
          key={`${q.value}-${idx}`}
          type="button"
          onClick={() => onSelect(q.value)}
          className={styles.quickChip}
          disabled={disabled}
        >
          {q.label}
        </button>
      ))}
    </div>
  );
}
